module.exports = __webpack_public_path__ + "img/product-icon.ce162be2.svg";